import { Directive } from '@angular/core';

@Directive({
  selector: '[timeline-dot]'
})
export class TimelineDotDirective {

  constructor() { }

}
